// extracted by mini-css-extract-plugin
export default {"Title":"Column_Title__InTlH","Column":"Column_Column__uJ-XX","Links":"Column_Links__AmFO+"};